module.exports = __webpack_public_path__ + "620e7013a1e295f6668edf82c57edb03.svg";